export default {
  SET_ACTION(state, action) {
    if (action == 'create' || action == 'update') {
      state.action = action;
    }
  },

  SET_FETCHED_POSTER(state, poster) {
    state.poster.fetchedPoster = poster;
  },

  SET_POSTER(state, fetchedPoster) {
    let poster = Object.assign({}, fetchedPoster);
    state.poster = poster;
  },

  SET_THEME(state, theme){
      state.selector.theme = theme;
  },

  SET_POSTER_ID(state, poster_id) {
    state.poster.id = poster_id;
  },

  SET_FIELDS(state, fields) {
    state.poster.fields = fields;
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/mutations.js